import React, { useEffect, useMemo, useState } from "react";
import css from "@/components/Listing/table/.module.scss";
import Icon from "@/components/icon";
import { financialFormat } from "@/lib/helpers";

const ALLOWED_ZERO_FIELDS = {
  family: {},
  age: {},
};
export function NewSpecsComponent({
  listing,
  fields = [],
  extendedFields = [],
} = {}) {
  const [canExpand, setCanExpand] = useState(false);

  const [specsWithIcons, booleanFields] = useMemo(() => {
    const specs = fields
      .map((field) => {
        if (typeof field.options?.find === "function" && !field.showRealValue) {
          return listing[field.name] != null && listing[field.name] != null
            ? /* [field,value,name */ {
                ...field,
                value: field.options.find((opt) => {
                  try {
                    if (opt.value + "" === listing[field.name] + "")
                      return true;
                    const { lte, lt, gt, gte, eq } = opt.value || {};
                    if (eq !== undefined && listing[field.name] !== undefined) {
                      return listing[field.name] + "" === lt + "";
                    }
                    if (lt !== undefined && listing[field.name] !== undefined) {
                      return +listing[field.name] < +lt;
                    }
                    if (
                      lte !== undefined &&
                      listing[field.name] !== undefined
                    ) {
                      return +listing[field.name] <= +lte;
                    }

                    if (gt !== undefined && listing[field.name] !== undefined) {
                      return +listing[field.name] > +gt;
                    }
                    if (
                      gte !== undefined &&
                      listing[field.name] !== undefined
                    ) {
                      return +listing[field.name] >= +gte;
                    }
                  } catch {}
                  return false;
                })?.label?.ar,
              }
            : undefined;
        }
        return listing[field.name] != null && listing[field.name] != null
          ? /* [field,value,name */ { ...field, value: field.type==='float'?financialFormat(listing[field.name]):listing[field.name] }
          : undefined;
      })
      /* Exclude price and content */
      .filter((field) => {
        if (!field) return false;
        if (!field.value && !ALLOWED_ZERO_FIELDS[field.name]) return false;
        if (!field.value || field.type === "boolean") return false;
        if (listing?.is_auction && field.name === "meter_price") return false;
        return !"price_content_rent_period".includes(field.name);
      })
      .sort((a) => (a.icon ? -1 : 1));

    const extenedSpecs = extendedFields
      .map((field) => {
        if (typeof field.options?.find === "function" && !field.showRealValue) {
          return listing.extended_details?.[field.name] != null &&
            listing.extended_details?.[field.name] != null
            ? /* [field,value,name */ {
                ...field,
                value: field.options.find(
                  (a) =>
                    a.value + "" ===
                    listing.extended_details?.[field.name] + "",
                )?.label?.ar,
              }
            : undefined;
        }
        return listing?.extended_details?.[field.name]
          ? /* [field,value,name */
            {
              ...field,
              value: listing?.extended_details?.[field.name],
            }
          : undefined;
      })
      /* Exclude price and content */
      .filter((field) => {
        if (!field) return false;
        if (!field.value && !ALLOWED_ZERO_FIELDS[field.name]) return false;
        if (!field.value || field.type === "boolean") return false;
        return !"price_content_rent_period".includes(field.name);
      });

    const extendedBooleanSpecs = extendedFields
      .filter((f) => f?.type === "boolean")
      .concat(...fields.filter((f) => f.type === "boolean"))
      .map(({ value, ...field }) => ({
        ...field,
        value: listing?.extended_details?.[field.name] || listing?.[field.name],
      }))
      /* Exclude price and content */
      .filter((field) => field?.value);
    return [[...specs, ...extenedSpecs], extendedBooleanSpecs];
  }, [listing, fields, extendedFields]);
  useEffect(() => {
    setCanExpand(true);
  }, [listing.id]);

  return (
    <>
      <h4>التفاصيل</h4>
      <div className={css.newSpecCard}>
        {specsWithIcons.map((field) => (
          <div className={css.item} key={field.name}>
            <div className={css.label}>
              {field.icon ? (
                <Icon width={20} height={20} name={field.icon || "Circle"} />
              ) : (
                <span
                  style={{
                    width: 20,
                    height: 20,
                  }}
                />
              )}
              {field.label.ar}
            </div>
            <div className={css.value}>
              {field.value}
              {field.suffix?.ar}
            </div>
          </div>
        ))}
      </div>
      {booleanFields.length ? (
        <>
          <h4>المميزات </h4>

          <div
            onClick={() => setCanExpand(!canExpand)}
            className={`${css.newSpecCard} ${
              canExpand && booleanFields?.length > 8 ? css.canExpand : ""
            } ${css.boolean}`}
          >
            {booleanFields.map((field, index) => (
              <div key={field.name + index} className={css.label}>
                <span
                  style={{
                    width: 20,
                    height: 20,
                    borderRadius: ".5rem",
                    padding: ".3rem",
                    display: "inline-flex",
                    justifyContent: "center",
                    alignItems: "center",
                    background: "rgba(92,184,92,0.2)",
                  }}
                >
                  <Icon width={20} height={20} name="v1/checkmark" />
                </span>
                {field.label.ar}
              </div>
            ))}
          </div>
        </>
      ) : null}
    </>
  );
}
